import { CaptchaMode } from '../../services/exports/Constants';
import useLoading from '../global/useLoading';
import useStorefront from '../storefront/useStorefront';

/**
 * How the captcha can render on this host, or null while that is not known yet.
 *
 * A shop embedded in a restaurant website always takes the iframe, as it always has, and knows it
 * from the first render. Everywhere else the store config decides: shop-backend answers `iframe`
 * for a restaurant served under a partner's own root, whose hostname no captcha vendor has
 * registered, and `direct` on the platform roots, which are allow-listed. Until the config has
 * loaded the answer is null, and the captcha waits rather than guess. Outside the provider that
 * loads it nothing ever will, so the answer there is direct.
 */
export default function useCaptchaMode(): CaptchaMode | null {
  const { isStorefront } = useStorefront();
  const loading = useLoading();

  if (isStorefront) {
    return CaptchaMode.Iframe;
  }

  if (!loading) {
    return CaptchaMode.Direct;
  }

  return loading.captchaMode;
}
